/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import _ from 'lodash';

class MultiLineNav extends Component {
  handleNavDown = (e) => {
    e.stopPropagation();
    this.props.onNavDown();
  };

  handleNavUp = (e) => {
    e.stopPropagation();
    this.props.onNavUp();
  };

  render() {
    const equation = this.props.equations[this.props.index];
    const disableDn =
      _.isEmpty(equation) && equation === _.last(this.props.equations);
    const disableUp = this.props.index === 0;

    return (
      <ButtonGroup className="multiline-nav">
        <Button onClick={this.handleNavDown} disabled={disableDn}>
          <span className="sr-only" />
        </Button>
        <Button onClick={this.handleNavUp} disabled={disableUp}>
          <span className="sr-only" />
        </Button>
      </ButtonGroup>
    );
  }
}

export default MultiLineNav;
